class ManifestService {
  constructor() {}
}

export { ManifestService };
